export interface IRole {
  id: string;
  name: string;
  description: string;
  permissions: {[key: string]: string[]};
  attributes: {[key: string]: string[]};
  isSelectableCustomers: boolean;
  isSelectableCustomerClients: boolean;
  isSelectableDepots: boolean;
  isInternalRole?: boolean;
}

export interface IRoleCreate {
  name: string;
  description: string;
  permissions: {[key: string]: string[]}
  isSelectableCustomers: boolean;
  isSelectableCustomerClients: boolean;
  isSelectableDepots: boolean;
  isInternalRole?: boolean;
}

export interface IRoleUpdate {
  id: string;
  description: string;
  permissions: {[key: string]: string[]};
  isSelectableCustomers: boolean;
  isSelectableCustomerClients: boolean;
  isSelectableDepots: boolean;
  isInternalRole?: boolean;
}

export interface IRoleDelete {
  ids: string[];
}

export const ROLES_KEY = "ROLES_KEY"

export const attrKeyForCustomers = "IsSelectableCustomers"
export const attrKeyForCustomerClients = "IsSelectableCustomerClients"
export const attrKeyForDepots = "IsSelectableDepots"
